<ftr-animated-remote [remote]="contactDetails" [successTemplate]="success">
  <ng-template #success let-configuration>
    @if (configuration.contactDetails) {
      <p class="help__description">For your current court, contact:</p>
      <div elevioArticle [articleId]="configuration.contactDetails"></div>
    }
  </ng-template>
</ftr-animated-remote>
